<template>
    <ac-modal ref="modal" :title="'Manage Providers'">
        <template>
            <div class="row">
                <div class="col-md-6">
                    <input placeholder="Provider name" class="form-control" type="text" style="height:45px;"
                           @input="filterTrees" @keydown.tab.prevent="onTab" ref="searchInput">
                </div>
            </div>
            <div class="row" style="margin-top:20px;">
                <div class="col-md-6" v-for="currentTree in trees">
                    <ac-kendo-tree :data="[currentTree]" @OnNodeSelected="onNodeSelected" ref="trees">

                    </ac-kendo-tree>
                </div>
            </div>
        </template>
    </ac-modal>
</template>

<script>
    import {mapGetters} from 'vuex';
    import _ from 'lodash';
    import {common} from "../../../global/common.js";
    import {providerUtilities} from "./utilities.js";

    export default {
        name: "ProviderImpersonationModal",
        data() {
            return {
                treesWithVisibleItems: [],
                entityTypeId: 0
            };
        },
        created() {
            this.filterTrees = _.debounce((e) => {
                let searchText = e.target.value;
                //console.log("search text:", searchText);
                this.treesWithVisibleItems = [];
                _.each(this.$refs.trees, (tree) => {
                    //console.log("current tree:", tree);
                    tree.filter(searchText);
                    if (tree.hasVisibleItems()) {
                        this.treesWithVisibleItems.push(tree);
                    }
                });
            }, 500);
        },
        computed: {
            ...mapGetters({
                trees: 'myProviders/trees'
            }),
            roleId() {
                return common.getRoleByEntityId(this.entityTypeId);
            }
        },
        mounted() {
            $(this.$refs.modal.$refs.modal).off('shown.bs.modal').on('shown.bs.modal', () => {
                //console.log("modal has been shown");
                this.$nextTick().then(() => {
                    //console.log("this.$refs.searchInput in next tick:", this.$refs.searchInput);
                    this.$refs.searchInput.focus();
                });
            })
        },
        methods: {
            async showModal(entityTypeId) {
                this.entityTypeId = entityTypeId;
                this.$refs.modal.open();
            },
            onNodeSelected(nodeSelected) {
                //console.log("Node has been selected", nodeSelected);
                this.goToProfile(nodeSelected);
            },
            onTab() {
                //console.log("this.treesWithVisibleItems:", this.treesWithVisibleItems);
                if (this.treesWithVisibleItems.length > 0) {
                    //console.log("first match:", this.treesWithVisibleItems[0].$refs.tree);
                    $(this.treesWithVisibleItems[0].$refs.tree).data("kendoTreeView").wrapper.focus();
                }
            },
            goToProfile(provider) {
                this.redirectToDashboard(provider.roleName, provider.providerEntityId);
                // if (provider.roleId === this.roleId) {
                //     this.redirectToDashboard(provider.roleName, provider.providerEntityId);
                // } else {
                //     providerUtilities.switchRoles(provider.providerEntityId);
                // }
            },
            redirectToDashboard(role, providerEntityId) {
                this.$refs.modal.close();
                window.location.href = `/${role.toLowerCase()}/#/${providerEntityId}/dashboard`;
            }
        }
    }
</script>

<style scoped>

</style>